// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"3682":"743aa85c","3973":"d1a727b0"}[chunkId] + ".chunk.css");